// Per-device claim registry for cook-session Live Activities.
//
// Both CookMode (when the lead has it open) and useTeamLiveActivity
// (the cross-device mirror hook) drive iOS BoodaTimer for the same
// clientId. If both fire on the same device they'd race. The hook
// always runs at App level; CookMode only runs while open.
//
// The rule: this device's Live Activity is owned by whichever consumer
// claimed the session id first. CookMode claims on mount and releases
// on unmount. The mirror hook checks before spawning — if claimed, it
// stays silent. So:
//
//   Lead's phone with CookMode open    → CookMode owns (real state)
//   Lead's other device (no CookMode)  → mirror hook owns
//   Helper / diner's any device        → mirror hook owns
//
// Module-level Set, intentional: needs to be reachable from a leaf
// component (CookMode) and an App-level hook (useTeamLiveActivity)
// without prop-drilling.

const claimed = new Set();

export function claimCookSession(sessionId) {
  if (!sessionId) return false;
  if (claimed.has(sessionId)) return false; // already claimed
  claimed.add(sessionId);
  return true;
}

export function releaseCookSession(sessionId) {
  if (!sessionId) return;
  claimed.delete(sessionId);
}

export function isCookSessionClaimed(sessionId) {
  if (!sessionId) return false;
  return claimed.has(sessionId);
}
